import { Button, Tabs } from 'antd'
import React, { FunctionComponent, useMemo } from 'react'
import { useRouteMatch } from 'react-router-dom'

import { LvDetailDrawer } from '../components/LvDetailDrawer/LvDetailDrawer'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { PropertyDetailDrawer } from '../components/PropertyDetailDrawer/PropertyDetailDrawer'
import { SubjectDetailAreaSummaryTab } from '../components/SubjectDetailAreaSummaryTab/SubjectDetailAreaSummaryTab'
import { SubjectDetailOwnershipTable } from '../components/SubjectDetailOwnershipTable/SubjectDetailOwnershipTable'
import { SubjectDetailPageTitle } from '../components/SubjectDetailPageTitle/SubjectDetailPageTitle'
import { SUBJECT_TAB_KEYS, TabItem, tabsProps } from '../utils/tabsHelpers'
import { useCheckClaims } from '../utils/useCheckClaims'
import { useTabKeyState } from '../utils/useTabKeyState'
import { useToggleState } from '../utils/useToggleState'

export const SubjectDetail: FunctionComponent = () => {
  const {
    params: { id },
  } = useRouteMatch<{ id: string }>()

  const tester = useCheckClaims('ApiVyvojar')
  const [history, toggleHistory] = useToggleState(false)

  const [activeTabKey, setActiveTabKey] = useTabKeyState<SUBJECT_TAB_KEYS>(
    SUBJECT_TAB_KEYS.OWNERSHIP
  )

  const tabItems = useMemo<TabItem<SUBJECT_TAB_KEYS>[]>(
    () => [
      {
        key: SUBJECT_TAB_KEYS.OWNERSHIP,
        label: 'Vlastnická práva',
        children: (
          <div className="bg-white px-4 py-6">
            <SubjectDetailOwnershipTable
              subjectId={id}
              searchHistory={history}
            />
          </div>
        ),
      },
      {
        key: SUBJECT_TAB_KEYS.SUMMARY,
        label: 'Sumace pozemků',
        children: (
          <div className="bg-white px-4 py-6">
            <SubjectDetailAreaSummaryTab subjectId={id} />
          </div>
        ),
      },
    ],
    [history, id]
  )

  const tabExtra = useMemo(() => {
    if (!tester) return null
    return (
      <Button type="primary" onClick={toggleHistory} ghost>
        {history ? 'DEV: Bez historie' : 'DEV: S historií'}
      </Button>
    )
  }, [history, tester, toggleHistory])

  return (
    <>
      <PageLayout
        title={<SubjectDetailPageTitle subjectId={id} />}
        isNew
        isNewTitle="Detail subjektu"
        isContainer
      >
        <Tabs
          {...tabsProps}
          items={tabItems}
          onTabClick={setActiveTabKey}
          activeKey={activeTabKey}
          tabBarExtraContent={tabExtra}
        />
      </PageLayout>
      <LvDetailDrawer />
      <PropertyDetailDrawer />
    </>
  )
}

export default SubjectDetail
